//import i18n from 'i18n-js';
import { I18n, TranslateOptions, Scope } from 'i18n-js';
import { LocaleType } from '../contentful/templates/types';
import { useLocation } from "@reach/router";

// Import all locales
import en from './data/en.json';
import fi from './data/fi.json';
import de from './data/de.json';
import fr from './data/fr.json';
import sv from './data/sv.json';
import no from './data/no.json';

const i18n = new I18n(
  { en, fi, de, fr, sv, no },
  { locale: 'fi', defaultLocale: 'fi' }
);

/*i18n.defaultLocale = 'fi';
i18n.missingTranslation = () => undefined;

i18n.translations = {
  en,
  fi,
};*/

// Todo validate scope
export const localize = (
  scope: Scope,
  options?: TranslateOptions,
): string => i18n.t(scope, options);

export const updateLocale = (locale: LocaleType) => (i18n.locale = locale);

const localeFromPrefix: Record<string, LocaleType> = {
  en: 'en', de: 'de', fr: 'fr', sv: 'sv', no: 'no',
};

export const resolveLocaleFromLocation = (location: Location): LocaleType =>
  localeFromPrefix[location.pathname.substring(1, 3)] || 'fi';

/** Hook to return current page locale */
export const useLocale = ()=>{
  const location = useLocation();
  return resolveLocaleFromLocation(location);
}